/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PendingUserInvite model module.
 * @module model/PendingUserInvite
 * @version V1
 */
class PendingUserInvite {
    /**
     * Constructs a new <code>PendingUserInvite</code>.
     * @alias module:model/PendingUserInvite
     */
    constructor() { 
        
        PendingUserInvite.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PendingUserInvite</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PendingUserInvite} obj Optional instance to populate.
     * @return {module:model/PendingUserInvite} The populated <code>PendingUserInvite</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PendingUserInvite();

            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('inviteUrl')) {
                obj['inviteUrl'] = ApiClient.convertToType(data['inviteUrl'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PendingUserInvite</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PendingUserInvite</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['inviteUrl'] && !(typeof data['inviteUrl'] === 'string' || data['inviteUrl'] instanceof String)) {
            throw new Error("Expected the field `inviteUrl` to be a primitive type in the JSON string but got " + data['inviteUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} userId
 */
PendingUserInvite.prototype['userId'] = undefined;

/**
 * @member {String} name
 */
PendingUserInvite.prototype['name'] = undefined;

/**
 * @member {String} inviteUrl
 */
PendingUserInvite.prototype['inviteUrl'] = undefined;






export default PendingUserInvite;

